import AppPageMetadata from "@crema/core/AppPageMetadata";
import AppsContainer from "@crema/core/AppsContainer";
import AppsContent from "@crema/core/AppsContainer/AppsContent";
import AppsHeader from "@crema/core/AppsContainer/AppsHeader";
import AppsPagination from "@crema/core/AppsPagination";
import { Input, Typography } from "antd";
import React, { useEffect } from "react";
import { useIntl } from "react-intl";
import SearchContextTable from "./SearchContextTable";
import {
  getSearchContextList,
  setPage,
  setSearch,
} from "redux/actions/SearchContext";
import { useDispatch, useSelector } from "react-redux";
import AwesomeDebouncePromise from "awesome-debounce-promise";

const debounceSearchOrder = AwesomeDebouncePromise(
  (search, dispatch) => {
    dispatch(setSearch(search));
    dispatch(setPage(1));
  },
  500,
  {
    onlyResolvesLast: true,
  }
);

const SearchContext = () => {
  const { messages } = useIntl();
  const dispatch = useDispatch();
  const { page, searchContext, total, search } = useSelector(
    ({ searchContext }) => searchContext
  );

  useEffect(() => {
    return () => {
      dispatch(setPage(1));
      dispatch(setSearch(""));
    };
  }, []);

  const onPageChange = (page) => {
    dispatch(setPage(page));
  };

  useEffect(() => {
    dispatch(
      getSearchContextList({
        search: search,
        page: page,
        limit: 10,
      })
    );
  }, [dispatch, page, search]);

  const onSearch = (e) => {
    debounceSearchOrder(e.target.value, dispatch);
  };
  return (
    <>
      <AppPageMetadata title="search context" />
      <AppsContainer
        title={messages["sidebar.admin.searchContext"]}
        fullView
        type="bottom"
      >
        <AppsHeader key={"wrap"}>
          <div className="customer-header">
            <div className="customer-header-input-view">
              <Input
                id="user-name"
                placeholder="Search"
                type="search"
                onChange={onSearch}
              />
            </div>
            <Typography style={{ padding: "0 0.5rem" }}>
              Total:{total}
            </Typography>
            <div className="customer-header-right">
              <AppsPagination
                className="customer-header-pagination"
                pageSize={10}
                count={total}
                current={page}
                page={page}
                onChange={onPageChange}
              />
            </div>
          </div>
        </AppsHeader>

        <AppsContent
          key={"wrap1"}
          style={{
            paddingTop: 10,
            paddingBottom: 10,
          }}
        >
          <SearchContextTable data={searchContext} />
        </AppsContent>
      </AppsContainer>
    </>
  );
};

export default SearchContext;
